export default "__VITE_ASSET__px2rYhpe__"